import SampleReportView from "@/components/samples/SampleReportView";
import { ALTUS_POWER_REPORT } from "@/data/sample-reports";

const AltusPowerSample = () => <SampleReportView report={ALTUS_POWER_REPORT} />;

export default AltusPowerSample;
